<template>
  <div>
    <!--    <v-row justify="center">-->
    <v-card>
      <div class="card-header py-3">
        <div class="card-title align-items-start flex-column mt-3">
          <h3 class="card-label font-weight-bolder text-dark">
            生成短效代理 API 接口
          </h3>
          <span class="text-muted font-weight-bold font-size-sm mt-1"
            >具有编程能力的开发者可在程序中调用API实时批量获取IP列表</span
          >
        </div>
      </div>

      <v-card-text>
        <v-container>
          <form class="form">
            <!--begin::Body-->
            <div class="card-body p-1">
              <div class="form-group row">
                <label class="col-xl-2 col-lg-2 col-form-label text-right pt-6"
                  >订单号（必填）</label
                >
                <div
                  class="form-group col-lg-9 col-xl-6 select-group input-group-solid"
                >
                  <select
                    name="country"
                    class="form-control form-control-solid form-control-lg"
                    v-model="form.order_id"
                  >
                    <template v-for="item in result">
                      <option v-bind:key="item.order_id" :value="item.order_id">
                        {{ item.name }}
                      </option>
                    </template>
                  </select>
                  <span class="form-text">
                    您购买的短效代理的订单号，在<a
                      class="text-primary"
                      href="/oms/secret/order"
                      >短效代理</a
                    >可以查询到。如果您还未购买，点击<a
                      class="text-primary"
                      href="/oms/secret/order?code=secret&ip_num=10&api_rate=10&days=30"
                      >购买短效代理</a
                    >ip服务!</span
                  >
                </div>
              </div>

              <div class="form-group row">
                <label class="col-xl-2 col-lg-2 col-form-label text-right pt-6"
                  >提取数量（必填）</label
                >
                <div class="col-lg-9 col-xl-6">
                  <div class="input-group input-group-lg input-group-solid">
                    <input
                      ref="business_name"
                      type="number"
                      required
                      class="form-control form-control-lg form-control-solid"
                      placeholder="提取 IP 数量"
                      v-model.number="form.ip_num"
                      :max="maxNum"
                      step="5"
                      min="5"
                    />
                  </div>
                  <span class="form-text text-muted">建议少量分批提取</span>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-xl-2 col-lg-2 col-form-label text-right pt-6"
                  >返回格式（选填）</label
                >
                <div
                  class="form-group col-lg-9 col-xl-6 select-group input-group-solid"
                >
                  <select
                    name="country"
                    class="form-control form-control-solid form-control-lg"
                    v-model="form.format"
                  >
                    <template v-for="item in formatResult">
                      <option v-bind:key="item.value" :value="item.value">
                        {{ item.name }}
                      </option>
                    </template>
                  </select>
                  <span class="form-text text-muted"
                    >api返回结果的格式，不了解具体含义的，请保持默认即可</span
                  >
                </div>
              </div>

              <div class="form-group row">
                <label class="col-xl-2 col-lg-2 col-form-label text-right pt-6"
                  >换行符格式（选填）</label
                >
                <div
                  class="form-group col-lg-9 col-xl-6 select-group input-group-solid"
                >
                  <select
                    name="country"
                    class="form-control form-control-solid form-control-lg"
                    v-model="form.line_split"
                  >
                    <template v-for="item in lineSplitResult">
                      <option v-bind:key="item.value" :value="item.value">
                        {{ item.name }}
                      </option>
                    </template>
                  </select>
                  <span class="form-text text-muted"
                    >该选项只在返回格式是文本格式的时候生效，不了解具体含义的，请保持默认即可</span
                  >
                </div>
              </div>

              <div class="form-group row">
                <label class="col-xl-2 col-lg-2 col-form-label text-right pt-6"
                  >允许重复ip（选填）</label
                >
                <div class="col-lg-9 col-xl-6">
                  <select
                    name="country"
                    class="form-control form-control-solid form-control-lg"
                    v-model="form.can_repeat"
                  >
                    <template v-for="item in canRepeatResult">
                      <option v-bind:key="item.value" :value="item.value">
                        {{ item.name }}
                      </option>
                    </template>
                  </select>
                  <span class="form-text text-muted"
                    >选择是，系统会尽可能返回不重复的代理ip给用户，当代理池不足的时候，会返回重复的。选择否，当代理池不足，不返回重复的代理ip给用户</span
                  >
                </div>
              </div>
            </div>

            <!--end::Body-->
          </form>
        </v-container>
      </v-card-text>
      <v-card-actions class="row">
        <span class="text-center col-md-9">
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" dark @click="updateData"
            >生成接口</v-btn
          >
          <v-btn color="white ml-9" @click="copy">复制链接</v-btn>
        </span>
      </v-card-actions>
      <v-card-text>
        <v-container>
          <div class="card-body p-1">
            <div class="form-group row">
              <label class="col-xl-2 col-lg-2 col-form-label text-right pt-6"
                >生成结果</label
              >
              <div class="col-lg-9 col-xl-6">
                <div class="input-group input-group-lg input-group-solid">
                  <textarea
                    v-model="memo"
                    cols="25"
                    rows="5"
                    class="form-control form-control-solid form-control-lg"
                    placeholder=""
                  >
                  </textarea>
                </div>
              </div>
            </div>
          </div>
        </v-container>
        <b-alert :show="true" variant="warning" class="font-size-lg">
          <p>使用说明：</p>
          <p>1. 生成API链接，调用 HTTP GET 请求即可返回所需的代理IP列表</p>
          <p>2. 使用前请务必在用户中心添加白名单</p>
          <p>
            3. 请按照订单的规定的请求频率提取，如大量无效重复客户端IP将会被冻结
          </p>
        </b-alert>
      </v-card-text>

      <section>
        <div class="row">
          <h3
            class="font-weight-bolder text-dark col-xl-3 col-lg-3 text-left pl-8"
          >
            返回结果示例
          </h3>
        </div>
        <b-alert :show="true" variant="dark">
          <pre class="text-light-info">
                    <span class="text-success">
          # 文本格式</span>
          1.1.1.1:20132
          2.2.2.2:24119
          3.3.3.3:10276
          4.4.4.4:51207
          5.5.5.5:15888
                  </pre>
          <pre class="text-light-info">
                    <span class="text-success">
          # JSON 格式
          # 注意：code 等于0表示请求正常，非0表示出现错误。具体错误请参考下面的错误码说明。
                    </span>
          {
            "code": 0,
            "result": [
                {
                    "host": "111.1.1.1",
                    "port": "34567",
                    "city_cn": "江苏省徐州市"
                },
                {
                    "host": "112.1.1.1",
                    "port": "34567",
                    "city_cn": "江苏省淮安市"
                },
                {
                    "host": "113.1.1.1",
                    "port": "34567",
                    "city_cn": "黑龙江鹤岗市"
                }
            ]
          }

                  </pre>
          <pre class="text-light-info">
                    <span class="text-success">
        # 常见错误返回结果
        # 注意：在返回格式设置为文本格式，但出现错误的时候，仍然会返回 JSON 格式的错误。
        # 建议将返回格式设置为 JSON。
                    </span>
        {
            "code": 21003,
            "message": "调用频率过快，请每隔10秒请求一次",
        }

        {
            "code": 21001,
            "message": "用户订单号xx不存在。"
        }

        {
            "code": 18003,
            "message": "剩余可提取代理数不足，剩余提取代理数：0，订单号：xx"
        }

        {
            "code": 21006,
            "message": "服务已过期,请续费后在操作！"
        }
                  </pre>
        </b-alert>
      </section>
      <section>
        <div class="row">
          <h3
            class="font-weight-bolder text-dark col-xl-3 col-lg-3 text-left pl-8"
          >
            代码请求示例
          </h3>
        </div>
        <div>
          <b-alert :show="true" variant="dark">
            <pre class="text-light-info">
                      <span class="text-success">
        # 以 Python3 为例，其他编程语言也类似，仅需发送 HTTP GET 请求接口即可</span>
        import requests

        # 点击上面的生成按钮生成的接口地址
        targetUrl = "***"

        resp = requests.get(targetUrl)

        print(resp.status_code)
        print(resp.text)
                    </pre>
          </b-alert>
        </div>
      </section>
    </v-card>
    <!--    </v-row>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_SERVICE } from "@/core/services/store/service.module";
import { stringify } from "qs";
export default {
  name: "GenerateApi",
  computed: {
    ...mapGetters(["currentUser"]),
  },
  watch: {
    form: {
      handler: function () {
        this.sumMaxNum();
      },
      deep: true,
    },
  },
  data() {
    return {
      email: "",
      maxNum: 10,
      memo: "",
      result: [],
      serviceRes: [],
      formatResult: [
        { name: "JSON", value: "json" },
        { name: "文本格式", value: "text" },
      ],
      lineSplitResult: [
        { name: "回车换行（\\r\\n，Windows 换行符）", value: "windows" },
        { name: "换行（\\n，UNIX 换行符）", value: "unix" },
        { name: "回车（\\r，macOS 换行符）", value: "mac" },
      ],
      canRepeatResult: [
        { name: "是", value: "yes" },
        { name: "否", value: "no" },
      ],
      code: "secret",
      form: {
        order_id: "",
        format: "text",
        line_split: "windows",
        can_repeat: "yes",
        ip_num: 5,
      },
    };
  },
  created() {
    this.memo = "";
    this.$store.dispatch(GET_SERVICE).then((res) => {
      this.serviceRes = res.result;
      res.result.forEach((item) => {
        if (item.product.code === "secret") {
          this.result.push({
            order_id: item._id["$oid"],
            name:
              item._id["$oid"] +
              " （短效代理-IP提取数" +
              item.product.ip_num +
              "-间隔" +
              item.product.api_rate +
              "秒）" +
              item.status,
          });
        }

        if (item._id["$oid"] === this.$route.query.order_id) {
          this.form.order_id = item._id["$oid"];
          this.form.ip_num = item.product.ip_num;
          this.maxNum = item.product.ip_num;
        }
      });
    });
  },
  methods: {
    updateData() {
      this.form.user_token = this.currentUser.token;
      this.memo = `https://api.beesproxy.com/api/v1/proxies/?${stringify(
        this.form
      )}`;
    },
    sumMaxNum() {
      this.serviceRes.forEach((item) => {
        if (this.form.order_id === item._id["$oid"]) {
          this.maxNum = item.product.ip_num;
        }
      });
    },
    copy() {
      navigator.clipboard.writeText(this.memo);
      this.$bvToast.toast("已复制到剪贴板", {
        title: "",
        variant: "success",
        toaster: "b-toaster-top-center",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-sale {
  position: absolute;
  top: -8px;
  right: 0;
  background-color: orange;
  color: #fff;
  font-size: 10px;
  height: 16px;
  padding: 1px 3px;
}
</style>
